<table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortea($event)" class="mat-elevation-z8"
    multiTemplateDataRows [matSortDisableClear]="true" matSortActive="patNm" matSortDirection="asc">

    <ng-container matColumnDef="CasNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="font10" style="width: 5rem;">{{engLang ?
            'Claim&nbsp;No.': 'Caso&nbsp;No.'}}</th>
        <td mat-cell *matCellDef="let clm" class="font10" style="width: 4rem;">
            <button mat-button class="link-button font12"
                (click)="openRecordCaseModal(clm.patNm, clm.CasNo + '-' + clm.CasOfNo,engLang,clm.PatID, clm.CasID)">
                {{clm.CasNo}}
            </button>
        </td>
    </ng-container>

    <!-- (click)="xtPID = clm.PatID; xtCID = clm.CasID;
                patNmModalHd = clm.patNm;
                casNoModalHd = clm.CasNo + '-' + clm.CasOfNo;
                open(recordCaseModal, { backdrop: 'static', size: 'lg', scrollable: true }, 'recordCaseModal', $event);"> -->

    <ng-container matColumnDef="CasOfNo">
        <th mat-header-cell *matHeaderCellDef class="text-center font10" style="width: 4rem;"
            matTooltip="{{engLang ? 'Office No.': 'No. Oficina'}}" matTooltipPosition="above">{{engLang ? 'Locale':
            'Local'}}</th>
        <td mat-cell *matCellDef="let clm" class="text-center font10" style="width: 4rem;"
            (click)="onClick_expandClm(clm.CasID,clm.ps)">
            {{clm.CasOfNo}}
        </td>
    </ng-container>

    <ng-container matColumnDef="ps">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after" class="font10"
            style="justify-items: flex-end;" style="width: 3rem;"
            matTooltip="{{engLang ? 'Primary/Secondary': 'Primario/Secundario'}}" matTooltipPosition="above">PS</th>
        <td mat-cell *matCellDef="let clm" class="text-center font10" style="width: 3rem;"
            (click)="onClick_expandClm(clm.CasID,clm.ps)">
            {{clm.ps}}
        </td>
    </ng-container>

    <ng-container matColumnDef="patNm">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center font10" style="width: 12rem;">{{engLang
            ? 'Patient': 'Paciente'}}</th>
        <td mat-cell *matCellDef="let clm" class="font10 ellipsis" appTooltipIfCollapsed [matTooltip]="clm.patNm"
            style="width: 10rem;" (click)="onClick_expandClm(clm.CasID,clm.ps)">
            {{clm.patNm}}
        </td>
    </ng-container>

    <ng-container matColumnDef="casUsual">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10">Usual</th>
        <td mat-cell *matCellDef="let clm" class="font10 rtalign ellipsis" appTooltipIfCollapsed
            [matTooltip]="clm.casUsual | currency:'USD':'':'0.2-2'" (click)="onClick_expandClm(clm.CasID,clm.ps)">
            {{clm.casUsual | currency:'USD':'':'0.2-2'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="casXpect">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10">{{engLang ? 'Expected':
            'Esperado'}}</th>
        <td mat-cell *matCellDef="let clm" class="font10 rtalign ellipsis" appTooltipIfCollapsed
            [matTooltip]="clm.casXpect | currency:'USD':'':'0.2-2'" (click)="onClick_expandClm(clm.CasID,clm.ps)">
            {{clm.casXpect | currency:'USD':'':'0.2-2'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="casIPayed">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10"
            matTooltip="{{engLang ? 'Plan payed': 'Pagado por el plan'}}" matTooltipPosition="above">{{engLang ?
            'Payed': 'Pagado'}}
        </th>
        <td mat-cell *matCellDef="let clm" class="font10 rtalign ellipsis" appTooltipIfCollapsed
            [matTooltip]="clm.casIPayed | currency:'USD':'':'0.2-2'" (click)="onClick_expandClm(clm.CasID,clm.ps)">
            {{clm.casIPayed | currency:'USD':'':'0.2-2'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="casBalance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font10"
            matTooltip="{{engLang ? 'Plan balance': 'Saldo del plan'}}" matTooltipPosition="above">Balance</th>
        <td mat-cell *matCellDef="let clm" class="font10 rtalign ellipsis" appTooltipIfCollapsed
            [matTooltip]="clm.casBalance | currency:'USD':'':'0.2-2'" (click)="onClick_expandClm(clm.CasID,clm.ps)">
            {{clm.casBalance | currency:'USD':'':'0.2-2'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="casBPvdo">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10"
            matTooltip="{{engLang ? 'Patient balance': 'Saldo del paciente'}}" matTooltipPosition="above">Bal&nbsp;P
        </th>
        <td mat-cell *matCellDef="let clm" class="font10 rtalign ellipsis" appTooltipIfCollapsed
            [matTooltip]="clm.casBPvdo | currency:'USD':'':'0.2-2'" (click)="onClick_expandClm(clm.CasID,clm.ps)">
            {{clm.casBPvdo | currency:'USD':'':'0.2-2'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="casDt">
        <td mat-header-cell *matHeaderCellDef mat-sort-header class="font10" style="justify-items: flex-end;">
            {{engLang ?
            'Date': 'Fecha'}}
        </td>
        <td mat-cell *matCellDef="let clm" class="font10 ellipsis" appTooltipIfCollapsed [matTooltip]="clm.casDt"
            (click)="onClick_expandClm(clm.CasID,clm.ps)">
            {{clm.casDt}}
        </td>
    </ng-container>

    <ng-container matColumnDef="expandDets"> <!-- Expand Details Column -->
        <td mat-cell *matCellDef="let row" [attr.colspan]="rptEspCobClmDisplydCols.length">
            <div *ngIf="showD" class="d-flex justify-content-between">
                <app-rpt-esp-cob-det [details]="detail" [payments]="payment" [engLang]="engLang"></app-rpt-esp-cob-det>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="rptEspCobClmDisplydCols; sticky: true" class="clm-header-row"></tr>
    <tr mat-row *matRowDef="let row; columns: rptEspCobClmDisplydCols;"
        [ngClass]="row.index % 2 === 0 ? 'clm-even-row' : 'clm-odd-row'">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandDets'];" [ngStyle]="{'display': (isExpanded(row) ? '' : 'none')}"
        [ngClass]="row.index % 2 === 0 ? 'clm-even-row' : 'clm-odd-row'">
    </tr>

</table>
<!-- <pre>{{dataSource.data | json2}}</pre> -->